import { useTranslation } from 'react-i18next'

import { useRegisterReload } from '../../../hooks'
import { EntityProfileTabsLoading } from '../../Entity'
import { TabScrollList } from '../../Tab'
import {
  useUserProfileContext,
  useUserProfileTabsActiveTab,
} from '../User.hooks'

import { useUserProfileTabsCounters } from './UserProfileTabs.hooks'
import {
  getUserProfileTabs,
  getUserProfileTabSectionCounters,
} from './UserProfileTabs.utils'

import * as styles from './UserProfileTabs.module.css'

function UserProfileTabs({ Empty = null, getProfileTabUrl, tabs, userData }) {
  const { t } = useTranslation()

  const { isInitiated, registerTabCountersReload } = useUserProfileContext()

  const { counters, handleLoadCounters, isCountersReady } =
    useUserProfileTabsCounters({
      tabs,
      userData,
    })

  useRegisterReload({
    reload: handleLoadCounters,
    onRegisterReload: registerTabCountersReload,
  })

  const preparedTabs = getUserProfileTabs({
    counters,
    isCountersLoading: !isCountersReady,
    t,
    tabs,
    userData,
  })

  const { activeTabId, handleSetActiveTab } = useUserProfileTabsActiveTab({
    getProfileTabUrl,
    preparedTabs,
    userData,
  })

  const activeTab = tabs.find(tab => tab.id === activeTabId)
  const ActiveTabContent = activeTab?.Content

  async function handleReloadTabCounters() {
    return handleLoadCounters([activeTabId])
  }

  return !isInitiated ? (
    <EntityProfileTabsLoading tabsClassName={styles.tabsWrapper} />
  ) : userData && preparedTabs.length > 0 ? (
    <>
      <TabScrollList
        activeTab={activeTabId}
        preparedTabs={preparedTabs}
        tabProps={{
          className: styles.tab,
        }}
        wrapperClassName={styles.tabsWrapper}
        onSetActiveTab={handleSetActiveTab}
      />
      {ActiveTabContent ? (
        <ActiveTabContent
          {...activeTab.contentProps}
          tabCounters={getUserProfileTabSectionCounters(counters, activeTabId)}
          userData={userData}
          onReloadTabCounters={handleReloadTabCounters}
        />
      ) : null}
    </>
  ) : userData && Empty ? (
    <Empty />
  ) : null
}

export default UserProfileTabs
